import { useCareManagementActivitiesQuery } from '@common/cache';

const defaultActivities = {
  plan: false,
  reconciliate: false,
  coordinate: false,
  educate: false,
  communicate: false,
};

export const useCareManagementActivitiesModal = ({
  patient_id,
  enabled,
}: {
  patient_id: string;
  enabled: boolean;
}) => {
  const {
    data = {
      activities: defaultActivities,
    },
  } = useCareManagementActivitiesQuery(patient_id, enabled);

  return {
    activities: data?.activities,
  };
};
